import ApiHelper from "../../utils/apiHelper";
// helpers
import { appSection, checkRedirection, hotelPanelRootUrl, pagesUrl } from "../../utils/panel-helpers/helpers";
// actions
import { globalActionCreators } from "./globalModule";

export const employeesActionTypes = {
  GET_ALL_CONCIERGES: "GET_ALL_CONCIERGES",
  GET_EMPLOYEES: "GET_EMPLOYEES",
  SET_DISTRIBUTORS_IN_DASHBOARD: "SET_DISTRIBUTORS_IN_DASHBOARD",
  SET_EMPLOYEES_IN_DASHBOARD: "SET_EMPLOYEES_IN_DASHBOARD",
  SET_DISTRIBUTORS_SORT: "SET_DISTRIBUTORS_SORT",
  SET_EMPLOYEES_SORT: "SET_EMPLOYEES_SORT",
  SET_LICENCES: "SET_LICENCES",
  SET_SELECTED_EMPLOYEE: "SET_SELECTED_EMPLOYEE"
};

export const initialState = {
  allConcierges: [],
  employees: [],
  employeesInDashboard: [],
  distributorsInDashboardEmployee: [],
  employeeSort: {
    column: null,
    direction: "desc"
  },
  distributorsSort: {
    column: null,
    direction: "desc"
  },
  licences: {
    mainLicenses: 0,
    employeeLicenses: 0
  },
  selectedEmployee: {}
};
export default (state = initialState, action) => {
  switch (action.type) {
    case employeesActionTypes.GET_ALL_CONCIERGES:
      return {
        ...state,
        allConcierges: action.allConcierges
      };
    case employeesActionTypes.GET_EMPLOYEES:
      return {
        ...state,
        employees: action.employees
      };
    case employeesActionTypes.SET_DISTRIBUTORS_IN_DASHBOARD:
      return {
        ...state,
        distributorsInDashboardEmployee: action.distributorsInDashboardEmployee
      };
    case employeesActionTypes.SET_EMPLOYEES_IN_DASHBOARD:
      return {
        ...state,
        employeesInDashboard: action.employeesInDashboard
      };
    case employeesActionTypes.SET_DISTRIBUTORS_SORT:
      return {
        ...state,
        distributorsSort: action.distributorsSort
      };
    case employeesActionTypes.SET_EMPLOYEES_SORT:
      return {
        ...state,
        employeeSort: action.employeeSort
      };
    case employeesActionTypes.SET_LICENCES:
      return {
        ...state,
        licences: action.licences
      };
    case employeesActionTypes.SET_SELECTED_EMPLOYEE:
      return {
        ...state,
        selectedEmployee: action.selectedEmployee
      };

    default:
      return state;
  }
};

export const employeesActionCreators = {
  setDistributorsInDashboardAction: distributorsInDashboardEmployee => {
    return {
      type: employeesActionTypes.SET_DISTRIBUTORS_IN_DASHBOARD,
      distributorsInDashboardEmployee
    };
  },
  setEmployeesInDashboardAction: employeesInDashboard => {
    return {
      type: employeesActionTypes.SET_EMPLOYEES_IN_DASHBOARD,
      employeesInDashboard
    };
  },
  sortDistributorsAction: distributorsSort => {
    return {
      type: employeesActionTypes.SET_DISTRIBUTORS_SORT,
      distributorsSort
    };
  },
  sortEmployeesAction: employeeSort => {
    return {
      type: employeesActionTypes.SET_EMPLOYEES_SORT,
      employeeSort
    };
  },
  setLicencesAction: licences => {
    return {
      type: employeesActionTypes.SET_LICENCES,
      licences
    };
  },
  setSelectedEmployeeAction: selectedEmployee => {
    return {
      type: employeesActionTypes.SET_SELECTED_EMPLOYEE,
      selectedEmployee
    };
  },
  // Loading all concierges for employee-concierge relations
  loadAllConciergesAction: hotelId => async (dispatch, getState) => {
    const isHotelGroupExistsState = getState().home.isHotelGroupExists;
    const hotelIdParam = isHotelGroupExistsState && hotelId ? `?hotelId=${hotelId}` : "";

    try {
      const res = await ApiHelper.get(`/v1/all-concierges${hotelIdParam}`);
      checkRedirection(res.request.responseURL);
      dispatch({
        type: employeesActionTypes.GET_ALL_CONCIERGES,
        allConcierges: res?.data
      });
    } catch (error) {
      dispatch(globalActionCreators.handleErrorAction());
    }
  },
  loadEmployeesAction: (hotelId, callSectionLoader) => async (dispatch, getState) => {
    const sectionLoadingNamesState = getState().global.sectionLoadingNames;
    if (sectionLoadingNamesState?.includes(pagesUrl?.employees)) {
      // disable new API call if we are still waiting for response
      return;
    }
    const isHotelGroupExistsState = getState().home.isHotelGroupExists;
    const hotelIdParam = isHotelGroupExistsState && hotelId ? `?hotelId=${hotelId}` : "";

    callSectionLoader(true, appSection?.employees);
    try {
      const res = await ApiHelper.get(`/v1/employees${hotelIdParam}`);
      checkRedirection(res.request.responseURL);
      dispatch({
        type: employeesActionTypes.GET_EMPLOYEES,
        employees: res?.data
      });
    } catch (error) {
      dispatch(globalActionCreators.handleErrorAction());
    } finally {
      callSectionLoader(false, appSection?.employees);
    }
  },
  updateEmployeeAction:
    (employeeName, employeeInitials, employeeNumber, conciergeId, onHandleFormMessage, onLoadEmployees, navigate) =>
    async (dispatch, getState) => {
      const employeeIdState = getState().employees.selectedEmployee.id;
      const isHotelGroupExistsState = getState().home.isHotelGroupExists;
      const selectedHotelsState = getState().global.selectedHotels;

      try {
        let bodyFormData = {
          firstName: employeeName,
          initials: employeeInitials,
          employeeNumber: employeeNumber,
          conciergeId: conciergeId
        };

        const res = await ApiHelper.post(`/v1/employee/edit/` + employeeIdState, {}, JSON.stringify(bodyFormData), {
          "Content-Type": "application/json"
        });

        onHandleFormMessage(res.data.status, "EditEmployee");
        isHotelGroupExistsState ? onLoadEmployees(selectedHotelsState[0]?.id) : onLoadEmployees();
        navigate(`/${hotelPanelRootUrl}/${pagesUrl.employees}`);
      } catch (error) {
        console.log(error);
      }
    },
  addEmployeeAction:
    (employeeName, employeeInitials, employeeNumber, conciergeId, onHandleFormMessage, onLoadEmployees, navigate) =>
    async (dispatch, getState) => {
      const isHotelGroupExistsState = getState().home.isHotelGroupExists;
      const selectedHotelsState = getState().global.selectedHotels;

      try {
        const bodyFormData = {
          firstName: employeeName,
          initials: employeeInitials,
          employeeNumber: employeeNumber,
          conciergeId: conciergeId
        };

        const res = await ApiHelper.post(`/v1/employee/new`, {}, JSON.stringify(bodyFormData), {
          "Content-Type": "application/json"
        });

        onHandleFormMessage(res.data.status, "AddEmployee");
        isHotelGroupExistsState ? onLoadEmployees(selectedHotelsState[0]?.id) : onLoadEmployees();
        navigate(`/${hotelPanelRootUrl}/${pagesUrl.employees}`);
      } catch (error) {
        console.log(error);
      }
    },
  deleteEmployeeAction: (onHandleFormMessage, onLoadEmployees, navigate) => async (dispatch, getState) => {
    const employeeIdState = getState().employees.selectedEmployee.id;
    const isHotelGroupExistsState = getState().home.isHotelGroupExists;
    const selectedHotelsState = getState().global.selectedHotels;

    try {
      const res = await ApiHelper.get(`/v1/employee/remove/` + employeeIdState, {}, undefined, undefined, {
        "Content-Type": "application/json"
      });

      onHandleFormMessage(res.data.status, "DeleteEmployee");
      isHotelGroupExistsState ? onLoadEmployees(selectedHotelsState[0]?.id) : onLoadEmployees();
      navigate(`/${hotelPanelRootUrl}/${pagesUrl.employees}`);
    } catch (error) {
      console.log(error);
    }
  }
};
